import { call } from '../../../utils/serviceUtils';
import {
  COMPANY_FTP_ADDRESS_GET,
  COMPANY_FTP_ADDRESS,
  } from '../../../config/paths';


export function getAllFtpAddress() {
  return call.get(COMPANY_FTP_ADDRESS_GET,
    {

    });
}

export function deleteFtpAddress(id) {
  return call.delete(COMPANY_FTP_ADDRESS + '/' + id,
  {
    
  });
}

export function createFtpAddress(data) {
  return call.post(COMPANY_FTP_ADDRESS, data);
}

export function updateFtpAddress(id,data) {
  return call.put(COMPANY_FTP_ADDRESS + '/' + id, data);
}



